import React, { Component } from 'react';

const BASE = '/idea-bet.live/theme/1ufaai/';

const faqs = [
    { q: 'UFAgrand168 คืออะไร?', a: 'UFAgrand168 เป็นแพลตฟอร์มการพนันออนไลน์ที่มีบริการหลากหลายประเภท เช่น การแทงบอลออนไลน์, คาสิโนออนไลน์, บาคาร่า, สล็อต, หวย และเกมอื่น ๆ' },
    { q: 'วิธีการสมัครสมาชิก UFAgrand168 ทำอย่างไร?', a: 'การสมัครสมาชิกกับ UFAgrand168 ง่ายมาก เพียงเข้าไปที่หน้าเว็บไซต์ กดปุ่มสมัครสมาชิก และกรอกข้อมูลส่วนตัวที่จำเป็น จากนั้นยืนยันการสมัครสมาชิกผ่านเบอร์โทรศัพท์ที่ได้ลงทะเบียนไว้' },
    { q: 'มีโปรโมชั่นและโบนัสอะไรบ้าง?', a: 'UFAgrand168 มีโปรโมชั่นและโบนัสมากมายสำหรับสมาชิกใหม่และสมาชิกเก่า เช่น โบนัสต้อนรับ, โบนัสเติมเงิน, สเต็ปฟรี 100 บาท, คืนยอดเสีย 5% และโปรโมชั่นพิเศษในช่วงเวลาต่าง ๆ' },
    { q: 'สามารถฝาก-ถอนเงินได้อย่างไร?', a: 'ผู้เล่นสามารถทำธุรกรรมฝาก-ถอนเงินผ่านระบบอัตโนมัติที่รวดเร็วและปลอดภัย โดยสามารถทำรายการได้ตลอด 24 ชั่วโมง ผ่านการโอนเงินผ่านธนาคารชั้นนำทุกแห่ง ไม่ต้องผ่านแอดมิน' },
    { q: 'การแทงบอลออนไลน์มีลีกและการแข่งขันอะไรบ้าง?', a: 'UFAgrand168 มีบริการแทงบอลออนไลน์ที่ครอบคลุมลีกและการแข่งขันฟุตบอลจากทั่วโลก เช่น พรีเมียร์ลีก, ลาลีกา, บุนเดสลีกา, เซเรียอา, ลีกเอิง และอีกมากมาย' },
    { q: 'ความปลอดภัยของข้อมูลและการทำธุรกรรมเป็นอย่างไร?', a: 'UFAgrand168 ใช้เทคโนโลยีการเข้ารหัสข้อมูล SSL เพื่อรักษาความปลอดภัยของข้อมูลส่วนบุคคลและธุรกรรมทางการเงิน ได้รับมาตรฐาน Certified Fair Gambling และ BMM Testlab Certified' },
    { q: 'มีบริการลูกค้าอย่างไรบ้าง?', a: 'UFAgrand168 มีทีมงานบริการลูกค้าตลอด 24 ชั่วโมง 7 วันต่อสัปดาห์ ผ่านช่องทางต่าง ๆ ได้แก่ LINE Official, Telegram, Facebook และระบบแชทสดในเว็บไซต์' },
    { q: 'สามารถเล่น UFAgrand168 ผ่านมือถือได้หรือไม่?', a: 'ได้เลย UFAgrand168 รองรับการเล่นผ่านมือถือทั้ง iOS และ Android รวมถึงแท็บเล็ตและคอมพิวเตอร์ ไม่ต้องดาวน์โหลดแอป เล่นผ่านเบราว์เซอร์ได้เลย' },
    { q: 'ต้องทำอย่างไรหากพบปัญหาในการใช้งาน?', a: 'หากพบปัญหาในการใช้งาน สามารถติดต่อทีมงานได้ตลอด 24 ชั่วโมงผ่าน LINE Official หรือ Telegram ทีมงานพร้อมช่วยเหลือและแก้ไขปัญหาให้อย่างรวดเร็ว' },
    { q: 'สามารถยกเลิกการเดิมพันได้หรือไม่?', a: 'เมื่อทำการวางเดิมพันและยืนยันแล้ว ไม่สามารถยกเลิกได้ ดังนั้นผู้เล่นควรตรวจสอบข้อมูลการเดิมพันให้ถูกต้องก่อนการยืนยันทุกครั้ง' },
];

class FaqPage extends Component {
    constructor(props) {
        super(props);
        this.state = { open: 0 };
    }

    render() {
        const { open } = this.state;
        return (
            <div className="x-question-and-answer-index-container x-default-bg-center" style={{ paddingTop: '72px', minHeight: '100vh' }}>
                <link rel="stylesheet" href={BASE + 'style.css'} />

                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h1 style={{ color: '#EFD0A0', fontSize: '26px', fontWeight: '700' }}>คำถามที่พบบ่อย</h1>
                        <p style={{ color: '#aaa' }}>ส่วนที่จะช่วยในการตัดสินใจให้เราบริการเกมคาสิโน แก่ท่านนักเดิมพัน</p>
                    </div>

                    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                        {faqs.map((item, i) => (
                            <div key={i} className="-question-and-answer-item" onClick={() => this.setState({ open: open === i ? null : i })}
                                style={{ border: '1px solid #b8962e', borderRadius: '10px', marginBottom: '10px', overflow: 'hidden', cursor: 'pointer', background: open === i ? 'rgba(184,150,46,0.15)' : 'rgba(0,0,0,0.4)' }}>
                                <div style={{ padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ color: '#EFD0A0', fontWeight: '600', fontSize: '15px' }}>{item.q}</span>
                                    <span style={{ color: '#EFD0A0', fontSize: '22px', lineHeight: 1 }}>{open === i ? '−' : '+'}</span>
                                </div>
                                {open === i && (
                                    <div className="-answer-detail" style={{ padding: '0 20px 18px', color: '#ccc', lineHeight: '1.8', fontSize: '14px', borderTop: '1px solid rgba(184,150,46,0.3)' }}>
                                        <br />{item.a}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}
export default FaqPage;
